// removed by extract-text-webpack-plugin
module.exports = {"login":"_3tp3HDHvzNsn9szgoVFnDw","tips":"_2z9JJ_RbwfZI5LUZOmZomo","error-tips":"_1toWq6xLjVNeYths38WdMt","close":"_2lX-EQb97jqtTbWEqU4K9b"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login/index.less
// module id = 373
// module chunks = 0